import { useEffect, useState } from "react";
import { MenuItem, Stack, Typography, ListItemText } from "@mui/material";
import { CustomCheckbox } from "../CustomCheckbox";
import { DataSources } from "../../../types/enums";

type Props = {
  items: DataSources[];
  setSourcesHandler: (value: DataSources[]) => void;
};

export const SelectDataSource = ({ items, setSourcesHandler }: Props) => {
  const [selected, setSelected] = useState<{ [key: string]: boolean }>({
    [items[0]]: true,
  });

  useEffect(() => {
    setSourcesHandler(
      Object.entries(selected).reduce(
        (acc, [key, value]) => (value ? [...acc, key as DataSources] : acc),
        [] as DataSources[],
      ),
    );
  }, [selected]);

  return (
    <Stack gap="12px">
      <Typography
        component="span"
        variant="subtitle1"
        color="custom.textDarkBlue"
        fontWeight={500}
      >
        Please choose the data sources for the accounts you want to export
      </Typography>

      <Stack>
        {items.map((el) => (
          <MenuItem
            key={el}
            sx={{
              padding: "4px",
            }}
            value={el}
            onClick={() =>
              setSelected((prev) => ({ ...prev, [el]: !prev[el] }))
            }
          >
            <CustomCheckbox checked={!!selected[el]} />
            <ListItemText
              primary={el}
              primaryTypographyProps={{
                sx: {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                },
              }}
            />
          </MenuItem>
        ))}
      </Stack>
    </Stack>
  );
};
